export const ORIGIN = 'https://bitbucket.org';
export const YML_FILE_NAME = 'bitbucket-pipelines.yml';
export const DOCS_CODE_INSIGHTS =
  'https://confluence.atlassian.com/display/BITBUCKET/Code+insights';
